import { Injectable } from '@angular/core';
import { EntityEditForm } from '../models/entity/edit/form';
import { CustomFieldType } from '../models/entity/custom-field';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class EntityApprovalService {

  needsApproval(entityEditForm: FormGroup<EntityEditForm>) {
    const { customFields, general } = entityEditForm.controls;
    const { avatar, description, email, name, profilePhoto, username, website } = general.controls;
    if (avatar.dirty && avatar.value?.length) return true;
    if (description.dirty && description.value) return true;
    if (email.dirty && email.value) return true;
    if (name.dirty && name.value) return true;
    if (profilePhoto.dirty && profilePhoto.value?.objectName) return true;
    if (username.dirty && username.value) return true;
    if (website.dirty && website.value) return true;
    for (const field of customFields.controls) {
      if (field.controls.fieldType.value === CustomFieldType.RichTextEditor) {
        if (field.controls.richTextEditor?.dirty) return true;
      } else if (field.controls.fieldType.value === CustomFieldType.Images) {
        if (field.controls.imagePicker?.dirty) return true;
      } else if (field.controls.fieldType.value === CustomFieldType.Videos) {
        if (field.controls.videoPicker?.dirty) return true;
      } else if (field.controls.fieldType.value === CustomFieldType.AudioFile) {
        if (field.controls.audioPicker?.dirty) return true;
      } else if (field.controls.fieldType.value === CustomFieldType.PdfFile) {
        if (field.controls.pdfPicker?.dirty) return true;
      }
    }
    return false;
  }
}
